/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { SysqueGaugeModule } from './sysque-gauge.module';
export { SysqueGaugeComponent } from './sysque-gauge-component';
